<template>
  <div style="width: 100%">
    <v-dialog
      v-model="stateValues.showIdentityCreatedDialog"
      max-width="600"
      @click:outside="createAnotherIdentity"
    >
      <v-card class="pa-3">
        <v-card-text
          class="d-flex flex-column justify-center align-center"
          style="min-height: 200px"
        >
          <v-icon class="mb-6" size="64" color="primary"
            >mdi-check-circle-outline</v-icon
          >
          <h2 class="dialog-title">{{ $t("newIdentityCreated") }}</h2>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <div class="d-flex justify-center" style="width: 100%">
            <v-btn color="primary darken-1 mr-3" to="/onboarding/leadparty">
              {{ $t("toList") }}
            </v-btn>

            <v-btn color="primary darken-1" @click="createAnotherIdentity">
              {{ $t("newCustomer") }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SimpleWarningDialog
      v-if="stateValues.showNoNfcWarningDialog"
      :title="$t('no_nfc_warning_title')"
      :text="$t('no_nfc_warning_text')"
      @onPrimary="onNoNfcWarningDialogClosed"
    />

    <div class="wrapper">
      <div class="title-wrapper">
        <h1 class="title">
          {{ $t("CreateNewIdentity") }}
        </h1>
      </div>
      <v-form ref="form" :lazy-validation="false">
        <div class="content-container">
          <div class="content-wrapper">
            <v-row>
              <v-col :cols="4">
                <v-text-field
                  v-model="stateValues.tckn"
                  :rules="[rules.tcknRequired, rules.tcknValidLength]"
                  :label="$t('TCKN')"
                  maxLength="11"
                  @keypress="isNumeric"
                  @blur="onTcknFieldFilled"
                  required
                ></v-text-field>
              </v-col>
              <v-col :cols="4">
                <v-text-field
                  v-model="stateValues.name"
                  :rules="[rules.nameRequired]"
                  :label="$t('name')"
                  maxLength="40"
                  @keypress="isLetter"
                  required
                ></v-text-field>
              </v-col>
              <v-col :cols="4">
                <v-text-field
                  v-model="stateValues.surname"
                  :rules="[rules.surnameRequired]"
                  :label="$t('surname')"
                  maxLength="40"
                  @keypress="isLetter"
                  required
                ></v-text-field>
              </v-col>
              <v-col :cols="4">
                <PhoneInput
                  v-model="stateValues.phoneNumber"
                  :label="$t('phoneNumber')"
                  :rules="[rules.phoneNumberRequired]"
                  :preferredCountries="preferredCountries"
                  :placeholder="''"
                  :mode="'international'"
                  @keypress="isNumeric"
                />
              </v-col>
              <v-col :cols="4">
                <v-text-field
                  v-model="stateValues.email"
                  :rules="[
                    rules.emailRequired,
                    rules.emailValid,
                    rules.emailValidLength
                  ]"
                  :label="$t('email')"
                  maxLength="255"
                  required
                  @paste="onPasteEmail"
                  @blur="onEmailFieldFilled"
                ></v-text-field>
              </v-col>
              <v-col :cols="4">
                <v-text-field
                  v-model="stateValues.addressCode"
                  :label="$t('addressCode')"
                  maxLength="255"
                ></v-text-field>
              </v-col>
              <v-col :cols="4">
                <v-select
                  v-model="unitCode"
                  :disabled="isBranchUser"
                  :items="unitCodeItems"
                  :label="$t('unit')"
                  item-text="unitType"
                  item-value="unitCode"
                  :no-data-text="$t('no_data_found')"
                ></v-select>
              </v-col>
              <v-col :cols="4">
                <v-select
                  v-model="stateValues.investmentConsultant"
                  :rules="[rules.investmentConsultantFieldRequired]"
                  :items="consultantItems"
                  :label="$t('investmentConsultant')"
                  maxLength="255"
                  :menuProps="{ maxHeight: 200 }"
                  :no-data-text="$t('no_data_found')"
                  required
                ></v-select>
              </v-col>
               <v-col :cols="4">
                <!--
                <v-select
                  :label="$t('nfcCompatiblePhone')"
                  :items="nfcCompatibleItems"
                  v-model="stateValues.selectedNfcCompatible"
                  item-text="text"
                  item-value="value"
                  @change="onSelectedNfcCompatibleChange"
                ></v-select> -->
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="buttons-wrapper" style="width: 100%">
          <v-btn
            class="mr-4"
            color="black"
            @click="clearForm"
          >
            <span class="color--primary--white">{{ $t("clear") }}</span>
          </v-btn>
          <v-btn
            color="#1e88e5"
            @click="submit"
            :disabled="stateValues.submitting"
            :loading="stateValues.submitting"
          >
            <span class="color--primary--white">{{
              $t("createIdentity")
            }}</span>
          </v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import CreateNewIdentity from "./mixin/CreateNewIdentity";

export default {
  mixins: [CreateNewIdentity]
};
</script>

<style lang="scss" scoped>
$primaryColor: #0032a0;

.h-100p {
  height: 100%;
}

.wrapper {
  width: 100%;
}

.v-form {
  margin-top: 2%;
}
.wrapper_image {
  cursor: pointer;
  text-align: center;
  span {
    color: $primaryColor;
    font-weight: bold;
  }
}
.wrapper-modal-actions {
  width: 100%;
  text-align: center;

  .v-btn {
    width: 80%;
    margin-bottom: 3%;
  }
}
.header-icon-wrapper {
  text-align: center;
  padding-top: 20px;
  .v-icon {
    font-size: 5rem;
  }
}
.wrapper-modal-title {
  text-align: center;
  margin-top: 5%;
}
.wrapper-modal-text {
  text-align: center;
}

.actions-wrapper {
  width: 100%;
  text-align: center;
  .v-btn {
    width: 49%;
  }
}
.dialog-title {
  font-size: 28px;
}
</style>



// WEBPACK FOOTER //
// src/pages/createnewidentity/CreateNewIdentity.vue